export const getScrollParent = (element: Element): HTMLElement => {
    if (!element) {
        return null;
    }
    const { overflowY } = window.getComputedStyle(element);
    const isScrollable =
        (overflowY === "auto" || overflowY === "scroll") && element.clientHeight < element.scrollHeight;
    return isScrollable ? (element as HTMLElement) : getScrollParent(element.parentElement);
};
